import { IParsedOption, OptionType, TradegramHelper } from "./TradegramHelper";

export interface IOptionPattern {
  parse (optionName: string): IParsedOption,
  isValid (optionName: string): boolean,
}

export abstract class OptionPattern implements IOptionPattern{

  protected abstract pattern: RegExp

  abstract parse (optionName: string): IParsedOption;

  isValid (optionName: string) {
    return optionName.length > 0 && this.pattern.test(optionName);
  }
  
}

